import { Expose } from "class-transformer";

export class CreateTimeOffHasUserDto {
  @Expose()
  timeOffId: string;

  @Expose()
  userId: string;
}
